(function() {
    angular
        .module('rms.common')
        .factory('ActivityInputService', ActivityInputService);

    function ActivityInputService(lodash) {
        return {
            initInputOptions: initInputOptions,
            getTypeDefaultValue:getTypeDefaultValue,
        };

        function initInputOptions(currentData, activityType, inputOptions, attachmentOptions) {
            const newData = angular.copy(currentData);
            lodash.set(newData, 'model.type', activityType.value);
            lodash.set(newData, 'options', activityType);
            lodash.set(newData, 'inputOptions', inputOptions);
            lodash.set(newData, 'attachmentOptions', attachmentOptions);

            lodash.forIn(newData.options.elements, function (element) {
                const modelFieldName = ['model', element.name].join('.');
                if (!lodash.has(newData, modelFieldName)) {
                    lodash.set(newData, modelFieldName, getTypeDefaultValue(element));
                }
            });
            return newData;
        }

        function getTypeDefaultValue(element) {
            switch (element.type) {
                case 'select':
                    if (lodash.has(element, 'options.maxItems')) {
                        return (element.options.maxItems == null || element.options.maxItems > 1) ? [] : '';
                    } else {
                        return '';
                    }
                case 'datepicker':
                case 'timepicker':
                    return new Date();
                case 'text':
                    return lodash.get(element, 'value', '');
                case 'readonly':
                    return element.value;
            }
        }
    }
})();